"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_TYPE = exports.DEFAULT_STYLE = exports.ARR_TEXT_TYPE = void 0;
const DEFAULT_STYLE = exports.DEFAULT_STYLE = {
  SUB: 'sub',
  LABEL_COLOR: 'neutral',
  HOVER_BACKGROUND: 'primary',
  BACKGROUND: 'default'
};
const TEXT_TYPE = exports.TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    lineHeight: 'normal'
  },
  sub: {
    type: 'sub',
    size: 'small',
    lineHeight: 'large'
  },
  small: {
    type: 'small',
    size: 'XSmall',
    lineHeight: 'small'
  }
};
const ARR_TEXT_TYPE = exports.ARR_TEXT_TYPE = Object.keys(TEXT_TYPE);